// @flow

import React from 'react';
import { Container, Col, Row } from 'reactstrap';

import { appendHoneyGuide } from '../../../lib/utils';
import {
  Page,
  PaymentSuccess,
  InjectInvoiceData,
  LodgeCard,
  CardsSlider,
} from '../../../components';
import { TransportationSummary } from '../Common';

const title = appendHoneyGuide('Payment Success');

export default function TransportationSuccessScreen(props) {
  return (
    <Page title={title}>
      <InjectInvoiceData>
        {({ lineItems, invoice }) => {
          return (
            <Container>
              <Row>
                <Col lg="6">
                  <PaymentSuccess className="form-cart" />
                  <CardsSlider
                    title="Featured Lodges"
                    endpoint="lodgings/lodges?is_featured=1"
                    Card={LodgeCard}
                    showNoOfCards={3}
                  />
                </Col>
                <TransportationSummary lineItems={lineItems} invoice={invoice} />
              </Row>
            </Container>
          );
        }}
      </InjectInvoiceData>
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Transportation/TransportationSuccess/TransportationSuccessScreen.js